import React from "react";
import { Outlet } from "react-router-dom";
import WidgetContainer from "../Common/WidgetContainer";
import MonitorsTab from "./MonitorsTab";
import NewFeature from "../Builder/Components/NewFeature";

const defaultWidgetLayout = [
  { i: "./MapOverviewWidget.jsx", x: 0, y: 0, w: 5, h: 10 },
  { i: "./UrgentAttentionWidget.jsx", x: 5, y: 0, w: 5, h: 10 },
  { i: "./EventsWidget.jsx", x: 10, y: 0, w: 5, h: 10 },
];

function MonitoringLandingPage() {
  return (
    <div className="">
      {/* <WidgetContainer
        defaultLayout={defaultWidgetLayout}
        lsField="monitoringWidgetLayout"
      /> */}

      <MonitorsTab />
      <Outlet />
    </div>
  );
}

export default MonitoringLandingPage;
